import request from '@/utils/request'


// 查询工资预支列表
export function listSalaryAdvance(query) {
  return request({
    url: '/user/salary-advance/list',
    method: 'get',
    params: query
  })
}

// 查询工资预支分页
export function pageSalaryAdvance(query) {
  return request({
    url: '/user/salary-advance/page',
    method: 'get',
    params: query
  })
}

// 查询工资预支详细
export function getSalaryAdvance(data) {
  return request({
    url: '/user/salary-advance/detail',
    method: 'get',
    params: data
  })
}

// 新增工资预支
export function addSalaryAdvance(data) {
  return request({
    url: '/user/salary-advance/add',
    method: 'post',
    data: data
  })
}

// 修改工资预支
export function updateSalaryAdvance(data) {
  return request({
    url: '/user/salary-advance/edit',
    method: 'post',
    data: data
  })
}

// 删除工资预支
export function delSalaryAdvance(data) {
  return request({
    url: '/user/salary-advance/delete',
    method: 'post',
    data: data
  })
}
